import React from 'react';
import cn from 'classnames';

import { MARGIN_RIGHT } from 'consts';

import { GridCardContainerProps } from '../types';

import { useDynamicGridViewer } from './hooks/useDynamicGridViewer/useDynamicGridViewer';

import styles from './DynamicGridViewer.module.scss';

interface Props<T extends { id: number }> {
  className?: string;
  children: ({ imageHeight, itemWidth, data }: GridCardContainerProps<T>) => React.ReactElement;
}

function DynamicGridViewer<T extends { id: number }>({ className, children }: Props<T>) {
  const {
    isFullLoaded,
    gridItems,
    imageHeight,
    itemWidth,
    virtualizer,
  } = useDynamicGridViewer();

  return (
    <div className={cn(styles.wrapper, className, { [styles.fullLoaded]: isFullLoaded })}>
      <div
        style={{
          height: `${virtualizer.getTotalSize()}px`,
          width: '100%',
          position: 'relative',
        }}
      >
        {virtualizer.getVirtualItems().map(({ index, lane, start }) => {
          const data = gridItems[index] as any; // TODO check the type and fix
          return (
            <div
              key={data.id}
              className={styles.card}
              style={{
                position: 'absolute',
                top: 0,
                left: `${lane * (itemWidth + MARGIN_RIGHT)}px`,
                width: `${itemWidth}px`,
                height: `${imageHeight}px`,
                transform: `translateY(${start}px)`,
              }}
            >
              {children({ imageHeight, itemWidth, data })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default React.memo(DynamicGridViewer) as typeof DynamicGridViewer;
